// extracted by mini-css-extract-plugin
export var wordContainer = "_pu-0";